import {
  KoBreadcrumb, KoButton, KoForm, KoLoader,
  KoModal, KoText, KoTicketTable, KoTitle, KoToast, KoTooltips
} from 'packages';
import KoIcon from '@kwapio/icons';
import { Collapse } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { add, remove } from 'shared/store/breadcrumbSlice';
import { getCookie } from 'shared/utils/cookies';
import TaskCrud from '../task/crud';
import { DevelopmentAPI } from '../development.service';
import styles from './retrospectives.module.scss';
import { Link } from 'react-router-dom';
import { getTicketBreadCrumb } from 'shared/commonConstants';
import CommnetsModal from 'shared/components/modals/comments';
import toast from 'react-hot-toast';

const Retrospectives = (props) => {

  const { workspaceId } = useParams();
  const { profile } = props;
  const dispatch = useDispatch();

  const userById = useSelector(state => state?.userById);
  const workspaceById = useSelector(state => state?.workspaceById);
  const workspaceDetails = workspaceById['data'];

  const [isLoading, setLoading] = useState(false);
  const [isOpen, setModal] = useState(false);
  const [totalcount, setTotalCount] = useState();
  const [sprints, setSprints] = useState([]);
  const [sprintTickets, setSprintTickets] = useState({});
  const [activeSprint, setActiveSprint] = useState(null);

  const [filters, setFilters] = useState({});
  const [pagination, setPagination] = useState({});

  const [isCommnetsModalOpen, setCommnetsModal] = useState(false);
  const [isOpenDelete, setDeleteModal] = useState(false);
  const [breadCrumbs, setBreadCrumbs] = useState();

  let userDetails = userById['data'];

  const [currentRecord, setCurrentRecord] = useState({
    status: 1,
    issueType: 2,
    priority: 3,
    reporter: userDetails?.userId
  });

  const [form] = KoForm.useForm();

  useEffect(() => {
    dispatch(remove());
    dispatch(add([
      { title: 'workspace', path: 'workspace' },
      { title: workspaceDetails?.name },
      { title: 'BackLogs' }
    ]));
  }, [workspaceDetails]);

  useEffect(() => { getSprints(); }, []);

  const getSprints = () => {
    try {
      setLoading(true);
      DevelopmentAPI.getRetrospectives(workspaceId).then((data) => {
        setSprints(data?.sprints || []);
      }).finally(() => setLoading(false));
    }
    catch (error) {
      toast.error("SomeThing Went Wrong");
      setLoading(false);
    }
  };

  const getRetrospectivesTickets = (sprintId) => {
    if (!sprintId) return;

    try {
      setLoading(true);

      const pageInfo = pagination[sprintId] || { page: 1, limit: 50 };

      const query = {
        ...filters,
        page: pageInfo.page,
        limit: pageInfo.limit
      };

      DevelopmentAPI.getRetrospectivesTickets(sprintId, workspaceId, query)
        .then((data) => {

          setSprintTickets(prev => ({
            ...prev,
            [sprintId]: data?.tickets || []
          }));
          setTotalCount(data?.totalCount);

          setPagination(prev => ({
            ...prev,
            [sprintId]: {
              page: data?.pages?.page || 1,
              limit: data?.pages?.limit || 50,
              total: data?.pages?.totalCount || 0
            }
          }));

        })
        .finally(() => setLoading(false));

    } catch (error) {
      toast.error("SomeThing Went Wrong");
      setLoading(false);
    }
  };

  const handleCollapseChange = (key) => {
    if (key.length === 0) {
      setActiveSprint(null);
      return;
    }
    setActiveSprint(key);
    if (!sprintTickets[key]) {
      console.log("Sprint id key:", key);

      getRetrospectivesTickets(key);
    }
  };

  const onChangeStatus = (key) => {
    setFilters(prev => ({
      ...prev,
      status: key ? key.toString() : undefined
    }));
  };
  const onChangeType = (key) => {
    setFilters(prev => ({
      ...prev,
      type: key ? key.toString() : undefined
    }));
  };

  const onChangePriority = (key) => {
    setFilters(prev => ({
      ...prev,
      priority: key ? key.toString() : undefined
    }));
  };

  const onChangeAssignees = (key) => {
    setFilters(prev => ({
      ...prev,
      assignee: key ? key.toString() : undefined
    }));
  };

  useEffect(() => {
    if (activeSprint) {
      getRetrospectivesTickets(activeSprint);
    }
  }, [filters]);

  const getIssueById = (ticketId) => {
    setLoading(true);
    DevelopmentAPI.getIssueById(ticketId, workspaceId)
      .then((data) => setCurrentRecord(data?.issue))
      .finally(() => setLoading(false));
  };

  const handleFinish = (values) => {
    setLoading(true);
    DevelopmentAPI.createOrUpdateIssues(values, currentRecord?.ticketId, workspaceId)
      .then(() => {
        setModal(false);
        getRetrospectivesTickets(activeSprint);
        form.resetFields();
        KoToast.success(`Ticket ${currentRecord?.ticketId ? 'updated' : 'created'} successfully`);
      })
      .finally(() => setLoading(false));
  };

  const DeleteIssues = () => {
    setLoading(true);
    DevelopmentAPI.deleteIssues(currentRecord?.ticketId, workspaceId)
      .then(() => {
        setDeleteModal(false);
        getRetrospectivesTickets(activeSprint);
        KoToast.success("Ticket deleted successfully");
      })
      .finally(() => setLoading(false));
  };

  const columnsRight = [{
    title: '',
    key: 'x',
    fixed: 'right',
    width: 80,
    render: (data, row) => (
      <div className={`${styles.circle} tableBtn columnsRight`}>
        <KoTooltips title="Copy">
          <KoButton
            iconBtn
            onClick={() =>
              navigator.clipboard.writeText(
                `${window.location.origin}/open/ticket/${getCookie("accountId")}/${row?.workspace}/${row?.ticketId}`
              )
            }
            icon={<KoIcon width={14} height={14} name={'CopyOutlined'} />}
          />
        </KoTooltips>

        <KoTooltips title="Open">
          <Link target="_blank" to={`/open/ticket/${getCookie("accountId")}/${row?.workspace}/${row?.ticketId}`}>
            <KoButton iconBtn icon={<KoIcon width={14} height={14} name={'OpenOutlined'} />} />
          </Link>
        </KoTooltips>

        <KoTooltips title="Delete">
          <KoButton
            iconBtn
            onClick={() => { setCurrentRecord(row); setDeleteModal(true); }}
            icon={<KoIcon width={14} height={14} name={'DeleteOutlined'} />}
          />
        </KoTooltips>
      </div>
    )
  }];

  const items = (sprints || []).map((sprint) => {

    return {
      key: sprint?.sprintId,
      label: (
        <div className={styles.sprintHeader}>
          <div className={styles.left}>
            <span className={styles.sprintTitle}>
              {(sprint?.name).charAt(0).toUpperCase() + (sprint?.name).slice(1)}
            </span>
          
          </div>
        </div>
      ),
      children: (
        <div className={styles.sprintWrapper}>
    
          <div className={styles.sprintTopBar}>
            <div className={styles.leftInfo}>
              <span className={styles.label}>Sprint</span>
              <span className={styles.value}>
                {(sprint?.name).charAt(0).toUpperCase() + (sprint?.name).slice(1)}
              </span>
            </div>

            <div className={styles.rightInfo}>
              <span className={styles.ticketBadge}>
                {totalcount} Tickets
              </span>
            </div>
          </div>

          <div className={styles.tableContainer}>
            <KoTicketTable
              setModal={setModal}
              profile={profile}
              API={DevelopmentAPI}
              form={form}
              getIssueById={getIssueById}
              workspaceId={workspaceId}
              onChangeStatus={onChangeStatus}
              onChangeType={onChangeType}
              onChangePriority={onChangePriority}
              onChangeAssignees={onChangeAssignees}
              RowSelectionOption={{ visible: true }}
              Bulk={{ visible: true }}
              tickets={sprintTickets[sprint.sprintId] || []}
              setLoading={setLoading}
              extraColumnsRight={columnsRight}
              setCurrentRecord={(row) => {
                setCurrentRecord(row);
                const crums = getTicketBreadCrumb(row, workspaceDetails);
                setBreadCrumbs(crums);
              }}
              setCommnetsModal={setCommnetsModal}
              onPagination={(page, limit) => {
                setPagination(prev => ({
                  ...prev,
                  [sprint.sprintId]: { page, limit }
                }));
                getRetrospectivesTickets(sprint.sprintId);
              }}
              getTicketsList={() => getRetrospectivesTickets(sprint.sprintId)}
              pagination={{
                page: pagination[sprint.sprintId]?.page || 1,
                limit: pagination[sprint.sprintId]?.limit || 50
              }}
              totalCount={totalcount}
            />
          </div>

        </div>
      )
    };
  });

  

  return (
    <div className={styles.retrospective}>
      {isLoading && <KoLoader />}
      <Collapse
        expandIconPosition="start"
        accordion
        className={styles.customCollapse}
        items={items}
        onChange={handleCollapseChange}
      />

      {isCommnetsModalOpen && (
        <CommnetsModal
          classNameMain={styles.wrapperOverflow}
          isCommnetsModalOpen={isCommnetsModalOpen}
          setCommnetsModal={() => setCommnetsModal(false)}
          workspaceId={currentRecord?.workspace}
          ticketId={currentRecord?.ticketId}
        />
      )}

      <KoModal
        title={breadCrumbs
          ? <KoBreadcrumb items={breadCrumbs} />
          : currentRecord?.ticketId
            ? `Update Issue ${currentRecord?.ticketId}`
            : `Create Issue`
        }
        centered
        open={isOpen}
        onClose={() => { setCurrentRecord(); setModal(false); form.resetFields(); }}
        width={'95vw'}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setModal(false)} />,
          <KoButton key='create' loading={isLoading} type='primary'
            label={currentRecord?.ticketId ? `Update` : `Create`}
            onClick={() => form.submit()} />
        ]}
      >
        <TaskCrud form={form} handleFinish={handleFinish} initialValues={currentRecord} profile={profile} />
      </KoModal>

      <KoModal
        title={`Delete Ticket ${currentRecord?.ticketId}`}
        centered
        open={isOpenDelete}
        onClose={() => setDeleteModal(false)}
        width={580}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setDeleteModal(false)} />,
          <KoButton key='delete' loading={isLoading} type='primary' label='Delete Ticket' onClick={DeleteIssues} />
        ]}
      >
        <div className={styles.wrapperModal}>
          <KoTitle level={5} text={`This action will delete item and cannot be undone`} />
          <KoText text={`Do you wish to proceed?`} />
        </div>
      </KoModal>
    </div>
  );
};
export default Retrospectives;